
const debug = false;

export class ForceableTimer<TResult = void> {
    private readonly defaultDelay: number;
    private readonly defaultExpiration: number;

    constructor(defaultDelay: number, defaultExpiration?: number) {
        this.defaultDelay = defaultDelay;
        this.defaultExpiration = defaultExpiration || null;
    }


    private expire: number = null;
    private timer: NodeJS.Timeout;
    private nonce: number;
    private timerAction: () => TResult;

    private trip(nonce: number): TResult {
        if (nonce !== this.nonce) {
            return;
        }
        if (this.timer) {
            if (debug) console.debug(`trip ${nonce}`);

            this.clear();
            return this.timerAction();
        }
    }
    public clear() {
        if (debug) console.debug(`clear ${this.nonce}`);
        if (this.timer)
            clearTimeout(this.timer);
        this.timer = null;
    }
    public set(func: () => TResult, delay?: number, expiration?: number) {
        if (this.timer) {
            if (debug) console.debug(`Set ${this.nonce}`);
            this.timerAction = func;
        }
        else {
            this.reset(func, delay || this.defaultDelay, expiration || this.defaultExpiration);
        }
    }
    public reset(func: () => TResult, delay?: number, expiration?: number) {
        const nonce = Date.now();
        let timeout: number = delay || this.defaultDelay;

        expiration = expiration || this.defaultExpiration;

        if (!this.timer) {
            if (expiration) {
                if (debug) console.info(`Set expire`);
                this.expire = Date.now().valueOf() + expiration;
                if (this.expire <= 0)
                    this.expire = null;
            }
            else {
                this.expire = null;
            }
        }
        else if (!expiration) {
            if (debug) console.info(`Clear '${expiration}'`);
            this.clear();
            this.expire = null;
        }

        if (this.expire) {
            const expires = this.expire - Date.now().valueOf();
            if (debug) console.log(`${timeout} - ${expires}`);
            if (expires < timeout) {
                if (debug) console.info(`Clip expire`);
                timeout = expires;
            }
            else {
                if (debug) console.info(`No clip ${timeout} - ${expires}`);
            }
        }

        if (debug) console.debug(`Reset: ${timeout} - ${nonce}`);

        this.timerAction = func;
        this.nonce = nonce;
        this.timer = setTimeout(() => this.trip(nonce), timeout);
    }
    public force(): TResult {
        return this.trip(this.nonce);
    }
}
